import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginator, PageEvent, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, catchError, takeUntil } from 'rxjs/operators';
import { of } from 'rxjs';
import { SessionDataService } from '../service/session-data.service';
import { SpinnerService } from '../../spinner-component/spinner.service';
import { SiteDetailsDialogComponent } from '../dailogs/site-details-dialog/site-details-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { AppConstants } from 'src/app/shared/app-constants';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { RestrictUserDialogComponent } from '../dailogs/restrict-user-dialog/restrict-user-dialog.component';
import { environment } from 'src/environments/environment';
import { ConfirmationDialogueComponent } from '../../confirmation-dialogue/confirmation-dialogue.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ChangePasswordDialogComponent } from '../dailogs/change-password-dialog/change-password-dialog.component';
import { PreferencesDialogComponent } from '../dailogs/preferences-dialog/preferences-dialog.component';
import { ConfigService } from 'src/app/services/config.service';
import { AssignedUsersDialogComponent } from '../dailogs/assigned-users-dialog/assigned-users-dialog.component';
import { SiteSummaryDetailsDialogComponent } from '../dailogs/site-summary-details-dialog/site-summary-details-dialog.component';
import { SiteReportModalComponent } from '../dailogs/site-report-modal/site-report-modal.component';
import { SiteReportService, EventData } from '../service/site-report.service';
import { UserManagementService } from 'src/app/services/user-management.service';

export interface User {
  lastLogin: string;
  name: string;
  username: string;
  emailid: string;
  countryCode: any;
  phone: any;
  sites: any;
  usertype: string;
}
export interface Sites {
  siteName: string;
  accountName: string;
  potentialId: any;
  accountId: any;
  summaryCount?: number;
  summaryData?: any;
}
@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule
  ]
})
export class UserManagementComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['name', 'username', 'emailid','phone','sites','usertype','lastLogin'];
  dataSource: MatTableDataSource<User>;
  sitesDataSource:MatTableDataSource<Sites>;
  displayedSitesColumns: string[] = ['siteName','accountName','analyticID', 'numberOfCameras', 'potentialId','accountId','status','stage', 'Users'];
  disableAdd: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  pageSize = 8;
  pageIndex = 0;
  sitePageIndex = 0;
  sitePageSize = 8;
  totalElements = 0;
  totalSites = 0;
  id: any;
  searchKeyword: string = '';
  myForm: FormGroup;
  userType: string = '';
  user:string='';
  los:string='';
  verified: string='';
  city:string='';
  state:string='';
  camera: number | '' = '';
  userName: any;
  status: string = 'active';
  selectedIndex: number = 0;
  totalPages: any;
  searchKey: any;
  cityKey: any;
  cameraKey: any;
  sitesForm: FormGroup;
  cfIssuesForm: FormGroup;
  currentUser: any;
  cfIssuesRtspLoading = false;
  cfIssuesPacketLossLoading = false;
  cfIssuesDockerLoading = false;
  cfIssuesSystemResourceLoading = false;
  cfIssuesApi1Result: any = null;
  cfIssuesApi2Result: any = null;
  cfIssuesApi3Result: any = null;
  cfIssuesApi4Result: any = null;
  cfSiteOptions: { siteName: string; potentialId: any; accountName?: string }[] = [];
  cfSiteSearch$ = new Subject<string>();
  private destroy$ = new Subject<void>();
  canAccessCfIssues = false;
  private restoreCfIssuesTab = false;
  canEditUsers: boolean;
  canViewUsers: any;
  activeFlag: any;
  numberOfCameras: any;
  csv:boolean=false;
  showDropdown = false;
  allowedUsers = ['sudarshan', 'gowthami'];
  
  // Site Report properties
  showReportDashboard = false;
  currentReportData: EventData[] = [];
  currentSiteName = '';
  isSuperAdmin: boolean = false;

  constructor(private sessionDataService: SessionDataService, public spinner: SpinnerService,private ngbModalService: NgbModal,
    public dialog: MatDialog, private toaster: ToastrService, private fb: FormBuilder, private router: Router,private authService: AuthenticationService,
  private configService: ConfigService, private siteReportService: SiteReportService, private userManagementService: UserManagementService) {
      this.myForm = this.fb.group({
        searchKeyword: ['']
      });
      this.sitesForm = this.fb.group({
        searchKey: [''],
        cityKey: [''],
        stateKey: [''],
        cameraKey: ['']
      });
      this.cfIssuesForm = this.fb.group({
        potentialId: ['']
      });
      this.currentUser = this.authService.currentUserValue;
      this.isSuperAdmin = this.userManagementService.isSuperAdmin();
      this.checkPrivileges();
     }

  ngOnInit(): void {
    this.setupCfSiteAutocomplete();
    const savedTab = localStorage.getItem('userMgmtTabIndex');
    if (savedTab !== null) {
      this.selectedIndex = +savedTab;
    }
    if (this.selectedIndex === 2) {
      this.restoreCfIssuesTab = true;
      this.selectedIndex = 0;
    }
    this.loadCfIssuesAccess();
    this.fetchUserData();
    
    // Load sites if the sites tab is selected initially
    if (this.selectedIndex === 1) {
      this.sitesDataSource = new MatTableDataSource([]);
      this.loadSites(this.sitePageSize, this.sitePageIndex);
    }
    
    const user = this.authService.currentUserValue;
    const currentUsername = (user?.firstName || '').toLowerCase().trim();
    const currentEmail = (user?.email || '').toLowerCase().trim();
    this.showDropdown =
      this.allowedUsers.includes(currentUsername) ||
      this.allowedUsers.some((name) => currentEmail.startsWith(name)) ||
      this.configService.isSuperAdmin();
    
    // Add summaryCount column only for users with showDropdown access
    if (this.showDropdown && !this.displayedSitesColumns.includes('summaryCount')) {
      this.displayedSitesColumns.push('summaryCount');
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setupCfSiteAutocomplete(): void {
    this.cfSiteSearch$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((search) => {
        if (!search || search.length < 2) {
          this.cfSiteOptions = [];
          return of([]);
        }
        return this.sessionDataService.getUsersByAll(search).pipe(
          catchError(() => of({ data: [] }))
        );
      }),
      takeUntil(this.destroy$)
    ).subscribe((response: any) => {
      const data = response?.data || response || [];
      this.cfSiteOptions = (Array.isArray(data) ? data : []).filter(
        (item: any) => item && (item.siteName || item.potentialId)
      );
    });
  }

  onCfSiteSearchInput(value: string): void {
    this.cfSiteSearch$.next(value?.trim() || '');
  }

  onCfSiteSelected(site: { siteName: string; potentialId: any }): void {
    this.cfIssuesForm.get('potentialId')?.setValue(site || '');
    this.cfSiteOptions = [];
  }

  displayCfSite(site: { siteName: string; potentialId: any } | string | null): string {
    if (!site) return '';
    if (typeof site === 'string') return site;
    return `${site.siteName || ''} (${site.potentialId || ''})`;
  }

  private loadCfIssuesAccess(): void {
    this.userManagementService.canAccessCfIssues()
      .pipe(takeUntil(this.destroy$))
      .subscribe((canAccess: boolean) => {
        this.canAccessCfIssues = canAccess;

        if (this.canAccessCfIssues && this.restoreCfIssuesTab) {
          this.selectedIndex = 2;
          return;
        }

        if (!this.canAccessCfIssues && this.restoreCfIssuesTab) {
          localStorage.setItem('userMgmtTabIndex', '0');
        }
      });
  }

  onTabChange(index: number): void {
    if (index === 2 && !this.canAccessCfIssues) {
      this.selectedIndex = 0;
      localStorage.setItem('userMgmtTabIndex', '0');
      return;
    }
    this.selectedIndex = index;
    localStorage.setItem('userMgmtTabIndex', index.toString());
    if (index === 1) {
      this.sitesDataSource = new MatTableDataSource([]);
      this.loadSites(this.sitePageSize, this.sitePageIndex);
    }
  }

  onSelectionChange(event: any, type: any): void {
    this.pageIndex = 0;
    if (type === 'userType') {
      this.userType = event.value;
    } else if (type === 'status') {
      this.status = event.value;
    } else if (type === 'user'){
      this.user = event.value;
    } else if (type === 'verified'){
      this.verified = event.value;
    }
    this.fetchUserData();
  }
  
  fetchUserData() {
    const userType = this.userType === 'All' ? '' : this.userType;
    const user = this.user === 'All' ? '' : this.user;
    const verified = this.verified === '' ? '' : this.verified;

    if(this.status == ''){
      this.activeFlag = []
    }
    else if(this.status == 'active'){
     this.activeFlag = true
    }
    else{
      this.activeFlag = false;
    }
    this.spinner.activate();
    let payload = {
      username :  this.myForm.get('searchKeyword').value ? this.myForm.get('searchKeyword').value : '',
      usertype : userType,
      user : user,
      verified : verified,
      status: this.activeFlag,
      page: this.pageIndex,
      size: this.pageSize,
    }
    this.sessionDataService.getUserDetails(payload).subscribe((data: any) => {
      this.spinner.deactivate();
      this.dataSource = data?.users || [];
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.totalElements = data?.totalelements || 0;
    });
  }

  checkPrivileges() {
    const role = this.currentUser?.role?.map(x => x.toLowerCase()) as Array<string>;
    const userMgmtFlag = this.configService.isFeatureEnabled('userMgmt');
  
    if (role?.includes('admin') || userMgmtFlag) {
      this.canViewUsers = true;
      this.canEditUsers = true;
      this.displayedColumns.push('action');
    } else if (role?.includes('view user access menu')) {
      this.canViewUsers = true;
      this.canEditUsers = false;
      this.displayedColumns = ['name', 'username', 'emailid', 'phone', 'sites', 'usertype', 'lastLogin'];
    } 
    else if (role?.includes('edit user access menu')) {
      this.canViewUsers = true;
      this.canEditUsers = true;
      this.displayedColumns = ['name', 'username', 'emailid', 'phone', 'sites', 'usertype', 'lastLogin','action'];
    } 
    else {
      this.canViewUsers = true;
      this.canEditUsers = false;
      this.displayedColumns = ['name', 'username', 'emailid', 'phone', 'sites', 'usertype', 'lastLogin'];
    }
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.fetchUserData()
  }

  onSitePageChange(event: PageEvent): void {
    this.sitePageSize = event.pageSize;
    this.sitePageIndex = event.pageIndex;
    this.loadSites(this.sitePageSize,this.sitePageIndex)
  }

  addUser(){
    this.router.navigate(['/cp/user-management/user'])
  }
  openSitesListDialog(element: any) {
    const filteredList = element?.potentialList.map(site => ({
      potentialName: site?.siteName,
      potentialId: site?.potentialId,
      siteType: site?.siteType
    }));
    this.dialog.open(SiteDetailsDialogComponent, {
      width: '600px',
      data: filteredList
    });
  }

  restrictUser(element:any){
    this.dialog.open(RestrictUserDialogComponent, {
      width: '600px',
      data: element
    });
  }

  changePassword(element:any){
    this.dialog.open(ChangePasswordDialogComponent, {
      width: '800px',
      data: element,
      panelClass: 'change-password-dialog-panel',
      autoFocus: false
    });
  }

  openPreferences(element:any){
    this.dialog.open(PreferencesDialogComponent, {
      width: '800px',
      data: element
    });
  }

  cameraConfig() {
    this.router.navigate(['/cp/user-management/camera-mapping'])
  }

  editUser(element:any){
    this.router.navigate([`/cp/user-management/user/${element.userName}`])
  }

  deleteUser(element:any) {
      let popupData = {
        title: "Delete Confirmation",
        message: `Are you sure you want to delete this user - ${element?.userName}`,
        cancelBtnText: "No",
        confirmBtnText: "Yes"
      }
      let dialoge = this.ngbModalService.open(ConfirmationDialogueComponent);
      dialoge.componentInstance._data = popupData;
      dialoge.result.then(data => {
        if (data) {
          this.id = element.id;
          const apiUrl = `${environment.workSpaceAPI}/user/delete/` + this.id;
          this.spinner.activate();
          this.sessionDataService.deleteUser(apiUrl, '').subscribe(
            (response) => {
              if (response && response.success) {
                this.spinner.deactivate();
                this.toaster.success('User Deleted Successfully..!');
                this.fetchUserData();
              } else {
                this.spinner.deactivate();
                this.toaster.error(
                  response?.message || AppConstants.defaultErrorMessage
                );
              }
            },
            (err) => {
              if (err) {
                this.spinner.deactivate();
                this.toaster.error(AppConstants.defaultErrorMessage);
              }
            }
          );
        }
      })
    }

  clearSearch(): void {
    this.myForm.get('searchKeyword')?.setValue('');
    this.pageIndex = 0;
    this.fetchUserData();
  }

  changeStatus(element:any) {
    let popupData = {
      title: "Change Status",
      message: `Are you sure you want to change the status of ${element?.userName} to Active?`,
      cancelBtnText: "No",
      confirmBtnText: "Yes"
    }
    let dialoge = this.ngbModalService.open(ConfirmationDialogueComponent);
    dialoge.componentInstance._data = popupData;
    dialoge.result.then(data => {
      if (data) {
        this.userName = element.userName; 
        const apiUrl = `${environment.workSpaceAPI}/user/status?username=` + this.userName;
        this.spinner.activate();
        this.sessionDataService.restrictUser(apiUrl).subscribe(
          (response) => {
            if (response && response.success) {
              this.spinner.deactivate();
              this.toaster.success('User Status Changed Successfully..!');
              this.fetchUserData();
            } else {
              this.spinner.deactivate();
              this.toaster.error(
                response?.message || AppConstants.defaultErrorMessage
              );
            }
          },
          (err) => {
            if (err) {
              this.spinner.deactivate();
              this.toaster.error(AppConstants.defaultErrorMessage);
            }
          }
        );
      }
    })
  }

  onSelectionSiteChange(event: any, type: any): void {
    this.pageIndex = 0;
    if (type === 'los') {
      this.los = event.value;
    } else if(type === 'city'){
      this.city = event.value;
    } else if(type === 'numberOfCameras'){
      this.numberOfCameras = event.value;
    } else if(type === 'state'){
      this.state = event.value;
    } else if (type === 'camera') {
      this.camera = event.value === '' ? '' : Number(event.value);
    } 
    this.fetchSiteData();
  }

  fetchSiteData(){
    const los = this.los === 'All' ? '' : this.los;
    const city = this.city === 'All' ? '' : this.city;
    const state = this.state === 'All' ? '' : this.state;
    const numberOfCameras= this.numberOfCameras === 'All' ? '' : this.numberOfCameras;
    const camera = this.camera === '' || this.camera === null ? '' : this.camera;
    
    if(this.status === ''){
      this.activeFlag = []
    }
    else if(this.status === 'active'){ 
     this.activeFlag = true
    }
    else{
      this.activeFlag = false;
    }
    this.spinner.activate();
    let payload = {
      los : los,
      city : city,
      state: state,
      numberOfCameras : numberOfCameras,
      camera : camera
    }
    this.sessionDataService.getSiteAddressDetails(payload).subscribe((data:any)=>{
      this.spinner.deactivate();

      this.dataSource = data?.sites || [];
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.totalElements = data?.totalelements || 0;
    })
    this.loadSites(8,0);
}

 loadSites(pageSize: number, pageIndex: number): void {
  this.spinner.activate();

  const searchKeyword = this.sitesForm.get('searchKey')?.value?.trim() || '';
  const searchCityKeyword = this.sitesForm.get('cityKey')?.value?.trim() || '';
  const searchStateKeyword = this.sitesForm.get('stateKey')?.value?.trim() || '';
  const searchCamEmptyKeyword = this.sitesForm.get('cameraKey')?.value;
  const los = this.los || '';

  const queryParams: string[] = [
    `page=${pageIndex}`,
    `size=${pageSize}`
  ];

  if (searchKeyword) queryParams.push(`search=${encodeURIComponent(searchKeyword)}`);
  if (searchCityKeyword) queryParams.push(`city=${encodeURIComponent(searchCityKeyword)}`);
  if (searchStateKeyword) queryParams.push(`state=${encodeURIComponent(searchStateKeyword)}`);
  if (searchCamEmptyKeyword !== null && searchCamEmptyKeyword !== undefined && searchCamEmptyKeyword !== '') {
    queryParams.push(`camera=${encodeURIComponent(searchCamEmptyKeyword)}`);
  }
  if (los) queryParams.push(`los=${encodeURIComponent(los)}`);

  const queryString = queryParams.join('&');
  const url = `${environment.workSpaceAPI}/user/getSites?${queryString}`;

  // const usersColumnIndex = this.displayedSitesColumns.indexOf('Users');
  // if (searchKeyword || searchCityKeyword || searchStateKeyword || searchCamEmptyKeyword || los) {
  //   if (usersColumnIndex === -1) {
  //     this.displayedSitesColumns.push('Users');
  //   }
  // } else {
  //   if (usersColumnIndex > -1) {
  //     this.displayedSitesColumns.splice(usersColumnIndex, 1);
  //   }
  // }

  this.sessionDataService.searchSites(url).subscribe({
    next: (response: any) => {
      this.spinner.deactivate();
      this.handleSites(response.data);
    },
    error: (error) => {
      this.spinner.deactivate();
    }
  });
}

  handleSites(data: any) {
    let dataArray: any[] = [];
    Object.keys(data.response).forEach((key) => {
      dataArray = dataArray.concat(data.response[key]);
    });
   this.sitesDataSource.data = dataArray.map(site => {
    let usersArray: string[] = [];
    try {
      usersArray = site.users ? JSON.parse(site.users) : [];
    } catch {
      usersArray = [];
    }
    return { ...site, users: usersArray, summaryCount: 0, summaryData: null };
  });
    this.totalSites = data?.totalElements;
    this.totalPages = data?.totalPages;
    this.paginator.length = this.totalSites;
    this.sitesDataSource.sort = this.sort;
    
    // Fetch summary data for each site
    this.fetchSummaryDataForSites();
  }

  fetchSummaryDataForSites(): void {
    const { fromDate, toDate } = this.getDateRange();
    this.sitesDataSource.data.forEach((site, index) => {
      if (!site?.potentialId) {
        return;
      }

      this.sessionDataService.getNewsletterData(site.potentialId, fromDate, toDate).subscribe({
        next: (response: any) => {
          const payload = response?.data ?? (response?.success === false ? null : response);
          if (payload && typeof payload === 'object') {
            const totalCount = this.calculateTotalCount(payload);
            const updatedSites = [...this.sitesDataSource.data];
            if (updatedSites[index]) {
              updatedSites[index] = {
                ...updatedSites[index],
                summaryCount: totalCount,
                summaryData: payload
              };
              this.sitesDataSource.data = updatedSites;
            }
          } else {
            const updatedSites = [...this.sitesDataSource.data];
            if (updatedSites[index]) {
              updatedSites[index] = {
                ...updatedSites[index],
                summaryCount: 0,
                summaryData: null
              };
              this.sitesDataSource.data = updatedSites;
            }
          }
        },
        error: (error) => {
          console.error(`Error fetching summary for site ${site.siteName}:`, error);
          const updatedSites = [...this.sitesDataSource.data];
          if (updatedSites[index]) {
            updatedSites[index] = {
              ...updatedSites[index],
              summaryCount: 0,
              summaryData: null
            };
            this.sitesDataSource.data = updatedSites;
          }
        }
      });
    });
  }

  getDateRange(): { fromDate: string, toDate: string } {
    const today = new Date();
    const toDate = new Date(today);
    const fromDate = new Date(today);
    fromDate.setDate(today.getDate() - 30); // Last 30 days
    
    const formatDate = (date: Date): string => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    
    return {
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate)
    };
  }

  calculateTotalCount(data: any): number {
    if (!data) return 0;
    return (data.humanReviewCount || 0) +
           (data.activityCount || 0) +
           (data.threatCount || 0) +
           (data.totalCrimeCount || 0) +
           (data.pcScCalled || 0) +
           (data.policeNotified || 0) +
           (data.alarmCount || 0);
  }

  clearSiteSearch(){
    this.sitesForm.get('searchKey')?.setValue('');
    this.sitesForm.get('cityKey')?.setValue('');
    this.sitesForm.get('stateKey')?.setValue('');
    this.sitesForm.get('cameraKey')?.setValue('');
    // const usersColumnIndex = this.displayedSitesColumns.indexOf('Users');
    //  if (usersColumnIndex > -1) {
    //  this.displayedSitesColumns.splice(usersColumnIndex, 1);
    //  }
    this.sitePageIndex = 0;
    this.sitePageSize = 8;
    this.loadSites(this.sitePageSize, this.sitePageIndex);
    
  }

  getCfPotentialId(): string {
    const raw = this.cfIssuesForm.get('potentialId')?.value;
    if (!raw) return '';
    if (typeof raw === 'object' && raw?.potentialId != null) return String(raw.potentialId).trim();
    return String(raw).trim();
  }

  private ensureCfIssuesAccess(): boolean {
    if (this.canAccessCfIssues) {
      return true;
    }
    this.toaster.warning('You do not have access to CF Issues.');
    return false;
  }

  runRtspCheck(): void {
    if (!this.ensureCfIssuesAccess()) {
      return;
    }
    const potentialId = this.getCfPotentialId();
    if (!potentialId) {
      this.toaster.warning('Please select or enter a Potential ID');
      return;
    }
    this.cfIssuesRtspLoading = true;
    this.cfIssuesApi1Result = null;
    this.sessionDataService.getRtspCheck(potentialId).subscribe({
      next: (res) => { this.cfIssuesApi1Result = res; this.cfIssuesRtspLoading = false; },
      error: (err) => {
        this.cfIssuesApi1Result = { error: err?.message || 'RTSP Check failed' };
        this.cfIssuesRtspLoading = false;
      }
    });
  }

  runPacketLossCheck(): void {
    if (!this.ensureCfIssuesAccess()) {
      return;
    }
    const potentialId = this.getCfPotentialId();
    if (!potentialId) {
      this.toaster.warning('Please select or enter a Potential ID');
      return;
    }
    this.cfIssuesPacketLossLoading = true;
    this.cfIssuesApi2Result = null;
    this.sessionDataService.getPacketLossCheck(potentialId).subscribe({
      next: (res) => { this.cfIssuesApi2Result = res; this.cfIssuesPacketLossLoading = false; },
      error: (err) => {
        this.cfIssuesApi2Result = { error: err?.message || 'Packet Loss Check failed' };
        this.cfIssuesPacketLossLoading = false;
      }
    });
  }

  runDockerServiceCheck(): void {
    if (!this.ensureCfIssuesAccess()) {
      return;
    }
    const potentialId = this.getCfPotentialId();
    if (!potentialId) {
      this.toaster.warning('Please select or enter a Potential ID');
      return;
    }
    this.cfIssuesDockerLoading = true;
    this.cfIssuesApi3Result = null;
    this.sessionDataService.getDockerServiceCheck(potentialId).subscribe({
      next: (res) => { this.cfIssuesApi3Result = res; this.cfIssuesDockerLoading = false; },
      error: (err) => {
        this.cfIssuesApi3Result = { error: err?.message || 'Docker Service Check failed' };
        this.cfIssuesDockerLoading = false;
      }
    });
  }

  runSystemResourceCheck(): void {
    if (!this.ensureCfIssuesAccess()) {
      return;
    }
    const potentialId = this.getCfPotentialId();
    if (!potentialId) {
      this.toaster.warning('Please select or enter a Potential ID');
      return;
    }
    this.cfIssuesSystemResourceLoading = true;
    this.cfIssuesApi4Result = null;
    this.sessionDataService.getSystemResourceCheck(potentialId).subscribe({
      next: (res) => { this.cfIssuesApi4Result = res; this.cfIssuesSystemResourceLoading = false; },
      error: (err) => {
        this.cfIssuesApi4Result = { error: err?.message || 'CPU and RAM Check failed' };
        this.cfIssuesSystemResourceLoading = false;
      }
    });
  }

  clearCfIssuesSearch(): void {
    this.cfIssuesForm.get('potentialId')?.setValue('');
    this.cfIssuesApi1Result = null;
    this.cfIssuesApi2Result = null;
    this.cfIssuesApi3Result = null;
    this.cfIssuesApi4Result = null;
  }

  downloadCSV(): void {
  this.spinner.activate();

  const userType = this.userType === 'All' ? '' : this.userType;
  const user = this.user === 'All' ? '' : this.user;
  const verified = this.verified || '';
  const activeFlag = this.status === '' ? [] : this.status === 'active' ? true : false;

  const payload = {
    page: 0,
    size: 1000,
    username: this.myForm.get('searchKeyword')?.value || '',
    usertype: userType,
    user: user,
    verified: verified,
    status: activeFlag,
    csv: true
  };

  this.sessionDataService.getUserCSV(payload).subscribe({
    next: (blob: Blob) => {
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = `user_data_${this.formatCurrentDateTime()}.csv`;
      a.click();
      window.URL.revokeObjectURL(url);
      this.spinner.deactivate();
    },
    error: (err) => {
      this.spinner.deactivate();
      this.toaster.error('CSV download failed.');
    }
  });
}

    formatCurrentDateTime() {
      const now = new Date();
      const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
    
      const month = monthNames[now.getMonth()];
      const day = now.getDate();
      let hours = now.getHours();
      const minutes = now.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';
    
      hours = hours % 12;
      hours = hours ? hours : 12;
      const minutesStr = minutes < 10 ? '0' + minutes : minutes;
    
      const formattedDateTime = `${month}_${day}_${hours}_${minutesStr}${ampm}`;
      return formattedDateTime;
    }

  openAssignedUsers(element:any){
    this.dialog.open(AssignedUsersDialogComponent, {
      width: '400px',
      data: element
    });
  }

  navigateToSummaryDetails(element: any): void {
    const id = element.potentialId || element.accountId;
    if (id) {
      this.router.navigate(['/cp/summary-details', id], {
        queryParams: { siteName: element.siteName || '' }
      });
    }
  }

  openSummaryDetailsDialog(element: any) {
    this.dialog.open(SiteSummaryDetailsDialogComponent, {
      width: '400px',
      data: {
        summaryData: element.summaryData,
        siteName: element.siteName,
        potentialId: element.potentialId,
        accountId: element.accountId,
        element: element
      }
    });
  }

  // Site Report Methods
  openSiteReportModal(siteName: string): void {
    console.log('Opening modal with site name:', siteName);
    console.log('Site name type:', typeof siteName);
    console.log('Site name length:', siteName?.length);
    
    const dialogRef = this.dialog.open(SiteReportModalComponent, {
      width: '90vw',
      maxWidth: '1200px',
      height: '90vh',
      maxHeight: '800px',
      data: { siteName: siteName },
      panelClass: 'site-report-modal'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Modal closed');
    });
  }

  generateSiteReport(siteName: string, fromDate: string, toDate: string): void {
    console.log('=== GENERATE SITE REPORT ===');
    console.log('Input siteName:', siteName);
    console.log('Input fromDate:', fromDate);
    console.log('Input toDate:', toDate);
    
    this.spinner.activate();
    this.toaster.info('Downloading site report data...');

    this.siteReportService.downloadSiteReport(siteName, fromDate, toDate).subscribe({
      next: (csvText: string) => {
        console.log('Received CSV data type:', typeof csvText);
        console.log('Received CSV data length:', csvText?.length);
        console.log('CSV data preview:', csvText?.substring(0, 500));
        
        // Check if csvText is null, undefined, or empty
        if (!csvText || csvText === null || csvText === undefined) {
          this.spinner.deactivate();
          this.toaster.error('No data received from the API. Please check the site name and date range.');
          console.error('CSV data is null or undefined');
          return;
        }
        
        // Check if csvText is empty string
        if (csvText.trim() === '') {
          this.spinner.deactivate();
          this.toaster.warning('No data found for the selected site and date range.');
          console.warn('CSV data is empty string');
          return;
        }
        
        this.processSiteReportData(csvText, siteName);
      },
      error: (error) => {
        this.spinner.deactivate();
        console.error('Site report download error:', error);
        
        if (error.status === 404) {
          this.toaster.error('No data found for the selected site and date range.');
        } else if (error.status === 403) {
          this.toaster.error('Access denied. Please check your permissions.');
        } else if (error.status === 0) {
          this.toaster.error('Network error. Please check your connection.');
        } else {
          this.toaster.error(`Failed to download site report (${error.status}). Please try again.`);
        }
      }
    });
  }

  private async processSiteReportData(csvText: string, siteName: string): Promise<void> {
    try {
      console.log('Processing CSV data for site:', siteName);
      console.log('CSV data type:', typeof csvText);
      console.log('CSV data length:', csvText?.length);
      
      const eventData = await this.siteReportService.parseCSVData(csvText);
      
      console.log('Parsed event data:', eventData);
      
      if (eventData.length === 0) {
        this.spinner.deactivate();
        this.toaster.warning('No data found for the selected date range.');
        return;
      }

      this.currentReportData = eventData;
      this.currentSiteName = siteName;
      this.showReportDashboard = true;
      
      this.spinner.deactivate();
      
      // Wait for charts to be ready before showing success message
      setTimeout(() => {
        this.toaster.success(`Successfully loaded ${eventData.length} events for ${siteName}`);
      }, 1000); // Wait 1 second for charts to render
      
    } catch (error) {
      this.spinner.deactivate();
      console.error('CSV processing error:', error);
      
      if (error instanceof Error) {
        this.toaster.error(`CSV Processing Error: ${error.message}`);
      } else {
        this.toaster.error('Failed to process CSV data. Please check the file format.');
      }
    }
  }

  closeReportDashboard(): void {
    this.showReportDashboard = false;
    this.currentReportData = [];
    this.currentSiteName = '';
  }

  // Test method to debug API issues
  testApiConnection(siteName: string, fromDate: string, toDate: string): void {
    console.log('Testing API connection...');
    this.siteReportService.testApiResponse(siteName, fromDate, toDate).subscribe({
      next: (response) => {
        console.log('API Response:', response);
        console.log('Response headers:', response.headers);
        console.log('Response body preview:', response.body?.substring(0, 1000));
        this.toaster.success('API test successful. Check console for details.');
      },
      error: (error) => {
        console.error('API test failed:', error);
        this.toaster.error(`API test failed: ${error.status} - ${error.statusText}`);
      }
    });
  }

  // Quick test method for debugging
  quickTest(): void {
    const testSiteName = 'JX Truck';
    const testFromDate = '2025-08-01';
    const testToDate = '2025-08-31';
    
    console.log('=== QUICK API TEST ===');
    console.log('Testing with:', { testSiteName, testFromDate, testToDate });
    
    this.testApiConnection(testSiteName, testFromDate, testToDate);
  }

  // Direct API test using fetch
  testApiDirectly(): void {
    // Use the exact working URL format
    const testUrl = 'https://pro-safe.pro-vigil.info:8011/api/reports/download/site?search=(JX%20Truck)%20Total%20Appearance%20F3605&fromDate=2025-08-01%2000%3A00%3A00&toDate=2025-08-31%2000%3A00%3A00';
    
    console.log('=== DIRECT API TEST ===');
    console.log('Testing API directly:', testUrl);
    
    fetch(testUrl)
      .then(response => {
        console.log('Response status:', response.status);
        console.log('Response status text:', response.statusText);
        console.log('Response headers:', response.headers);
        console.log('Response ok:', response.ok);
        return response.text();
      })
      .then(data => {
        console.log('Response data type:', typeof data);
        console.log('Response data length:', data?.length);
        console.log('Response data preview:', data?.substring(0, 500));
        
        if (data && data.length > 0) {
          this.toaster.success('API test successful! Data received.');
          console.log('CSV data sample:', data.substring(0, 1000));
        } else {
          this.toaster.warning('API returned empty data.');
        }
      })
      .catch(error => {
        console.error('Fetch error:', error);
        this.toaster.error(`API test failed: ${error.message}`);
      });
  }
  }
 
